// ABOUTME: Loads one job with its attempts (GET /api/job/jobs/:id) and keeps polling it while the
// ABOUTME: job can still change on its own, so the detail follows a running job to its end.

import { useCallback, useEffect, useRef, useState } from 'react';

import { getJob } from '../../api/jobApi';
import { Jobs, NON_TERMINAL_JOB_STATES } from '../../types';

const POLL_INTERVAL_MS = 3000;

export function useJobDetail(id: string | null | undefined) {
    const [job, setJob] = useState<Jobs | null>(null);
    const [error, setError] = useState<string | null>(null);
    const currentId = useRef(id);
    currentId.current = id;

    const refresh = useCallback(async () => {
        if (!id) return;
        try {
            const data = await getJob(id);
            // A late answer for a job the caller moved away from is dropped.
            if (currentId.current !== id) return;
            setJob(data);
            setError(null);
        } catch (e) {
            if (currentId.current !== id) return;
            setError(e instanceof Error ? e.message : String(e));
        }
    }, [id]);

    useEffect(() => {
        setJob(null);
        setError(null);
        refresh();
    }, [refresh]);

    const live = !!job && NON_TERMINAL_JOB_STATES.includes(job.state);

    useEffect(() => {
        if (!live) return undefined;
        const interval = setInterval(() => {
            if (!document.hidden) refresh();
        }, POLL_INTERVAL_MS);
        return () => clearInterval(interval);
    }, [live, refresh]);

    return { job, error, loading: !job && !error, refresh };
}
